import React, { useEffect } from 'react';

export function HtmlContentScreen({ captureResponse, handleModalClose }) {
  useEffect(() => {
    const handleIframeMessage = event => {
      if (event.data && event.data.source === 'go-saffe-capture') {
        const eventType = event.data.payload.event;
        if (['finish', 'close', 'timeout'].includes(eventType)) {
          handleModalClose();
        }
      }
    };

    window.addEventListener('message', handleIframeMessage);

    return () => {
      window.removeEventListener('message', handleIframeMessage);
    };
  }, [handleModalClose]);

  return (
    <iframe
      title="Capture Content"
      srcDoc={captureResponse}
      style={{ width: '100%', border: 'none', height: '669px' }}
      sandbox="allow-scripts allow-same-origin allow-forms"
    />
  );
}
